export default __webpack_public_path__ + "static/media/trzmiel.9e33addd.svg";